export interface XdrSearchWebComponentSchema {
  // all the data needed for rendering
}

export enum SearchEvents {
  RUN_QUERY = 'runQuery',
  QUERY_ERROR = 'queryError',
  QUERY_SUCCESS = 'querySuccess',
}

export enum ResultView {
  IN_PROGRESS = 'inProgress',
  INIT = 'init',
  NO_RESULTS = 'noResults',
}

export interface InputQueryConfig {
  input: string;
  updateInput: boolean;
}

export interface SmartViewItem {
  _id: string;
  query: string;
  name: string;
  companyId: string;
}

export interface RpcResponse {
  success: boolean;
  data?: string;
}

const FIELD_VALUES = {
  'network.direction': [
    {
      name: 'outbound',
      description: 'outbound',
    },
    {
      name: 'inbound',
      description: 'inbound',
    },
    {
      name: 'both',
      description: 'both',
    },
  ],
  'process.access_privileges': [
    {
      name: 'elevated',
      description: 'elevated',
    },
    {
      name: 'restricted',
      description: 'restricted',
    },
  ],
  'process.integrity_level': [
    {
      name: 'untrusted',
      description: 'untrusted',
    },
    {
      name: 'low',
      description: 'low',
    },
    {
      name: 'medium',
      description: 'medium',
    },
    {
      name: 'high',
      description: 'high',
    },
    {
      name: 'system',
      description: 'system',
    },
  ],
  'process.parent_access_privileges': [
    {
      name: 'elevated',
      description: 'elevated',
    },
    {
      name: 'restricted',
      description: 'restricted',
    },
  ],
  'process.parent_integrity_level': [
    {
      name: 'untrusted',
      description: 'untrusted',
    },
    {
      name: 'low',
      description: 'low',
    },
    {
      name: 'medium',
      description: 'medium',
    },
    {
      name: 'high',
      description: 'high',
    },
    {
      name: 'system',
      description: 'system',
    },
  ],
  'process.service_start_type': [
    {
      name: 'none',
      description: 'none',
    },
    {
      name: 'auto_start',
      description: 'auto_start',
    },
    {
      name: 'manual_start',
      description: 'manual_start',
    },
    {
      name: 'disabled_service',
      description: 'disabled_service',
    },
  ],
  'process.is_driver': [
    {
      name: 'yes',
      description: 'yes',
    },
    {
      name: 'no',
      description: 'no',
    },
  ],
  'file.attribute_operation': [
    {
      name: 'security_change',
      description: 'security_change',
    },
    {
      name: 'basic_attributes_change',
      description: 'basic_attributes_change',
    },
    {
      name: 'datetime_change',
      description: 'datetime_change',
    },
  ],
  'file.operation': [
    {
      name: 'read',
      description: 'read',
    },
    {
      name: 'write',
      description: 'write',
    },
    {
      name: 'delete',
      description: 'delete',
    },
    {
      name: 'rename',
      description: 'rename',
    },
    {
      name: 'close',
      description: 'close',
    },
    {
      name: 'create',
      description: 'create',
    },
  ],
  'file.item_type': [
    {
      name: 'file',
      description: 'file',
    },
    {
      name: 'folder',
      description: 'folder',
    },
    {
      name: 'web',
      description: 'web',
    },
    {
      name: 'site',
      description: 'site',
    },
    {
      name: 'tenant',
      description: 'tenant',
    },
    {
      name: 'library',
      description: 'library',
    },
  ],
  'file.is_remote': [
    {
      name: 'yes',
      description: 'yes',
    },
    {
      name: 'no',
      description: 'no',
    },
  ],
  'registry.operation': [
    {
      name: 'read',
      description: 'read',
    },
    {
      name: 'write',
      description: 'write',
    },
    {
      name: 'create',
      description: 'create',
    },
    {
      name: 'delete',
      description: 'delete',
    },
  ],
  'registry.type': [
    {
      name: 'none',
      description: 'none',
    },
    {
      name: 'sz',
      description: 'sz',
    },
    {
      name: 'expand_sz',
      description: 'expand_sz',
    },
    {
      name: 'binary',
      description: 'binary',
    },
    {
      name: 'dword',
      description: 'dword',
    },
    {
      name: 'dword_little_endian',
      description: 'dword_little_endian',
    },
    {
      name: 'dword_big_endian',
      description: 'dword_big_endian',
    },
    {
      name: 'link',
      description: 'link',
    },
    {
      name: 'multi_sz',
      description: 'multi_sz',
    },
    {
      name: 'resource_list',
      description: 'resource_list',
    },
    {
      name: 'full_resource_descriptor',
      description: 'full_resource_descriptor',
    },
    {
      name: 'resource_requirements_list',
      description: 'resource_requirements_list',
    },
    {
      name: 'qword',
      description: 'qword',
    },
  ],
  'email.logon_type': [
    {
      name: 'owner',
      description: 'owner',
    },
    {
      name: 'administrator',
      description: 'administrator',
    },
    {
      name: 'delegate',
      description: 'delegate',
    },
    {
      name: 'microsoft_transport_service',
      description: 'microsoft_transport_service',
    },
    {
      name: 'microsoft_service_account',
      description: 'microsoft_service_account',
    },
    {
      name: 'delegated_administrator',
      description: 'delegated_administrator',
    },
  ],
  'alert.actions_taken': [
    {
      name: 'invalid',
      description: 'invalid',
    },
    {
      name: 'no_action',
      description: 'no_action',
    },
    {
      name: 'block',
      description: 'block',
    },
    {
      name: 'block_and_disinfect',
      description: 'block_and_disinfect',
    },
    {
      name: 'disinfect_only',
      description: 'disinfect_only',
    },
    {
      name: 'delete',
      description: 'delete',
    },
    {
      name: 'quarantine',
      description: 'quarantine',
    },
  ],
  'alert.mark': [
    {
      name: 'info',
      description: 'info',
    },
    {
      name: 'suspicious',
      description: 'suspicious',
    },
    {
      name: 'malware',
      description: 'malware',
    },
  ],
  'alert.scan_type': [
    {
      name: 'on_access',
      description: 'on_access',
    },
    {
      name: 'on_demand',
      description: 'on_demand',
    },
    {
      name: 'http_traffic',
      description: 'http_traffic',
    },
  ],
  'alert.type': [
    {
      name: 'atd',
      description: 'atd',
    },
    {
      name: 'am',
      description: 'am',
    },
    {
      name: 'hd',
      description: 'hd',
    },
    {
      name: 'atd_beta',
      description: 'atd_beta',
    },
    {
      name: 'hd_report',
      description: 'hd_report',
    },
    {
      name: 'cmdline',
      description: 'cmdline',
    },
    {
      name: 'ctc',
      description: 'ctc',
    },
    {
      name: 'ghoster',
      description: 'ghoster',
    },
    {
      name: 'hd_no_report',
      description: 'hd_no_report',
    },
    {
      name: 'sandbox',
      description: 'sandbox',
    },
    {
      name: 'memory_scan',
      description: 'memory_scan',
    },
    {
      name: 'urlstatus',
      description: 'urlstatus',
    },
    {
      name: 'gemma',
      description: 'gemma',
    },
    {
      name: 'anomaly_detection',
      description: 'anomaly_detection',
    },
    {
      name: 'amsi',
      description: 'amsi',
    },
    {
      name: 'dynamic_ml',
      description: 'dynamic_ml',
    },
    {
      name: 'self_protect',
      description: 'self_protect',
    },
    {
      name: 'user_detection',
      description: 'user_detection',
    },
    {
      name: 'crypt_protect',
      description: 'crypt_protect',
    },
    {
      name: 'etw',
      description: 'etw',
    },
    {
      name: 'generic_heuristic_engine',
      description: 'generic_heuristic_engine',
    },
    {
      name: 'user_detection_yara',
      description: 'user_detection_yara',
    },
    {
      name: 'firewall',
      description: 'firewall',
    },
    {
      name: 'PHASR',
      description: 'PHASR',
    },
    {
      name: 'anti_tampering',
      description: 'anti_tampering',
    },
  ],
  'other.arch': [
    {
      name: 'x86',
      description: 'x86',
    },
    {
      name: 'x64',
      description: 'x64',
    },
  ],
  'other.detection_class': [
    {
      name: 'ransomware',
      description: 'ransomware',
    },
    {
      name: 'edr_detection',
      description: 'edr_detection',
    },
    {
      name: 'antimalware_scan_interface',
      description: 'antimalware_scan_interface',
    },
    {
      name: 'amsi_detection',
      description: 'amsi_detection',
    },
    {
      name: 'anomaly_detection',
      description: 'anomaly_detection',
    },
    {
      name: 'antimalware_detection',
      description: 'antimalware_detection',
    },
    {
      name: 'atd_beta_detection',
      description: 'atd_beta_detection',
    },
    {
      name: 'atd_detection',
      description: 'atd_detection',
    },
    {
      name: 'gemma_detection',
      description: 'gemma_detection',
    },
    {
      name: 'hd_detection',
      description: 'hd_detection',
    },
    {
      name: 'hd_no_report_detection',
      description: 'hd_no_report_detection',
    },
    {
      name: 'hd_report_detection',
      description: 'hd_report_detection',
    },
    {
      name: 'machine_learning_detection',
      description: 'machine_learning_detection',
    },
    {
      name: 'memory_scan_detection',
      description: 'memory_scan_detection',
    },
    {
      name: 'network_scan_detection',
      description: 'network_scan_detection',
    },
    {
      name: 'user_defined_detection',
      description: 'user_defined_detection',
    },
    {
      name: 'command_line_scanning_detection',
      description: 'command_line_scanning_detection',
    },
    {
      name: 'sandbox_detection',
      description: 'sandbox_detection',
    },
    {
      name: 'urlstatus_detection',
      description: 'urlstatus_detection',
    },
    {
      name: 'cryptprotect_detection',
      description: 'cryptprotect_detection',
    },
    {
      name: 'etw_detection',
      description: 'etw_detection',
    },
    {
      name: 'user_detection_yara',
      description: 'user_detection_yara',
    },
    {
      name: 'firewall_detection',
      description: 'firewall_detection',
    },
    {
      name: 'selfprotect_detection',
      description: 'selfprotect_detection',
    },
    {
      name: 'antiphishing_detection',
      description: 'antiphishing_detection',
    },
    {
      name: 'user_detection',
      description: 'user_detection',
    },
    {
      name: 'generic_heuristic_engine_detection',
      description: 'generic_heuristic_engine_detection',
    },
    {
      name: 'PHASR',
      description: 'PHASR'
    },
    {
      name: 'anti_tampering',
      description: 'anti_tampering'
    },
  ],
  'other.event_name': [
    {
      name: 'access_request_approved',
      description: 'access_request_approved',
    },
    {
      name: 'access_request_created',
      description: 'access_request_created',
    },
    {
      name: 'add_app_role_to_user',
      description: 'add_app_role_to_user',
    },
    {
      name: 'add_application',
      description: 'add_application',
    },
    {
      name: 'add_delegated_permission_grant',
      description: 'add_delegated_permission_grant',
    },
    {
      name: 'add_folder_permissions',
      description: 'add_folder_permissions',
    },
    {
      name: 'add_mailbox_permission',
      description: 'add_mailbox_permission',
    },
    {
      name: 'add_owner_to_app',
      description: 'add_owner_to_app',
    },
    {
      name: 'add_owner_to_service_principal',
      description: 'add_owner_to_service_principal',
    },
    {
      name: 'add_service_principal',
      description: 'add_service_principal',
    },
    {
      name: 'add_user',
      description: 'add_user',
    },
    {
      name: 'added_to_securelink',
      description: 'added_to_securelink',
    },
    {
      name: 'amsi_buffer',
      description: 'amsi_buffer',
    },
    {
      name: 'atc_detection',
      description: 'atc_detection',
    },
    {
      name: 'batchfile_executed',
      description: 'batchfile_executed',
    },
    {
      name: 'case_admin_updated',
      description: 'case_admin_updated',
    },
    {
      name: 'consent_to_application',
      description: 'consent_to_application',
    },
    {
      name: 'connection_over_common_port',
      description: 'connection_over_common_port',
    },
    {
      name: 'connection_protocol_identified',
      description: 'connection_protocol_identified',
    },
    {
      name: 'delete_kernel_module',
      description: 'delete_kernel_module',
    },
    {
      name: 'device_access_policy_changed',
      description: 'device_access_policy_changed',
    },
    {
      name: 'directory',
      description: 'directory',
    },
    {
      name: 'directory_create',
      description: 'directory_create',
    },
    {
      name: 'directory_delete',
      description: 'directory_delete',
    },
    {
      name: 'disk_eject',
      description: 'disk_eject',
    },
    {
      name: 'disk_mount',
      description: 'disk_mount',
    },
    {
      name: 'disk_unmount',
      description: 'disk_unmount',
    },
    {
      name: 'dns_unresolved',
      description: 'dns_unresolved',
    },
    {
      name: 'driver_load',
      description: 'driver_load',
    },
    {
      name: 'driver_unload',
      description: 'driver_unload',
    },
    {
      name: 'document_file_transferred',
      description: 'document_file_transferred',
    },
    {
      name: 'event_mount',
      description: 'event_mount',
    },
    {
      name: 'event_unmount',
      description: 'event_unmount',
    },
    {
      name: 'executable_file_write',
      description: 'executable_file_write',
    },
    {
      name: 'external_notification',
      description: 'external_notification',
    },
    {
      name: 'external_notification_on_file',
      description: 'external_notification_on_file',
    },
    {
      name: 'external_notification_on_process',
      description: 'external_notification_on_process',
    },
    {
      name: 'file',
      description: 'file',
    },
    {
      name: 'file_accessed',
      description: 'file_accessed',
    },
    {
      name: 'file_ads_create',
      description: 'file_ads_create',
    },
    {
      name: 'file_ads_read',
      description: 'file_ads_read',
    },
    {
      name: 'file_ads_write',
      description: 'file_ads_write',
    },
    {
      name: 'file_attributes_change',
      description: 'file_attributes_change',
    },
    {
      name: 'file_change_basic_attributes',
      description: 'file_change_basic_attributes',
    },
    {
      name: 'file_copy',
      description: 'file_copy',
    },
    {
      name: 'file_copied_using_com',
      description: 'file_copied_using_com',
    },
    {
      name: 'file_create',
      description: 'file_create',
    },
    {
      name: 'file_datetime_change',
      description: 'file_datetime_change',
    },
    {
      name: 'file_delete',
      description: 'file_delete',
    },
    {
      name: 'file_downloaded',
      description: 'file_downloaded',
    },
    {
      name: 'file_malware_detected',
      description: 'file_malware_detected',
    },
    {
      name: 'file_move',
      description: 'file_move',
    },
    {
      name: 'file_read',
      description: 'file_read',
    },
    {
      name: 'file_rename_move',
      description: 'file_rename_move',
    },
    {
      name: 'file_smb_create',
      description: 'file_smb_create',
    },
    {
      name: 'file_uploaded',
      description: 'file_uploaded',
    },
    {
      name: 'file_write',
      description: 'file_write',
    },
    {
      name: 'filescan_detection',
      description: 'filescan_detection',
    },
    {
      name: 'find_process',
      description: 'find_process',
    },
    {
      name: 'ftp_file_upload',
      description: 'ftp_file_upload',
    },
    {
      name: 'general_process_injection',
      description: 'general_process_injection',
    },
    {
      name: 'hard_delete',
      description: 'hard_delete',
    },
    {
      name: 'http_public_connection',
      description: 'http_public_connection',
    },
    {
      name: 'http_request_response',
      description: 'http_request_response',
    },
    {
      name: 'hw_description_registry_access',
      description: 'hw_description_registry_access',
    },
    {
      name: 'icacls_process_executed',
      description: 'icacls_process_executed',
    },
    {
      name: 'insert_kernel_module',
      description: 'insert_kernel_module',
    },
    {
      name: 'ipconfig_process_executed',
      description: 'ipconfig_process_executed',
    },
    {
      name: 'kerberos_connection',
      description: 'kerberos_connection',
    },
    {
      name: 'kerberos_ticket_request',
      description: 'kerberos_ticket_request',
    },
    {
      name: 'keychain_access_cert',
      description: 'keychain_access_cert',
    },
    {
      name: 'keychain_access_pwd',
      description: 'keychain_access_pwd',
    },
    {
      name: 'keychain_delete_item',
      description: 'keychain_delete_item',
    },
    {
      name: 'keychain_insert_cert',
      description: 'keychain_insert_cert',
    },
    {
      name: 'keychain_insert_pwd',
      description: 'keychain_insert_pwd',
    },
    {
      name: 'keychain_update_pwd',
      description: 'keychain_update_pwd',
    },
    {
      name: 'library_load',
      description: 'library_load',
    },
    {
      name: 'ldap_user_add_to_group',
      description: 'ldap_user_add_to_group',
    },
    {
      name: 'mail_items_accessed',
      description: 'mail_items_accessed',
    },
    {
      name: 'email_received',
      description: 'email_received',
    },
    {
      name: 'email_sent',
      description: 'email_sent',
    },
    {
      name: 'modify_folder_permissions',
      description: 'modify_folder_permissions',
    },
    {
      name: 'mstsc_process_executed',
      description: 'mstsc_process_executed',
    },
    {
      name: 'net_process_executed',
      description: 'net_process_executed',
    },
    {
      name: 'network_access_policy_changed',
      description: 'network_access_policy_changed',
    },
    {
      name: 'network_connect',
      description: 'network_connect',
    },
    {
      name: 'network_disconnect',
      description: 'network_disconnect',
    },
    {
      name: 'network_interface_added',
      description: 'network_interface_added',
    },
    {
      name: 'network_interface_change',
      description: 'network_interface_change',
    },
    {
      name: 'network_interfaces',
      description: 'network_interfaces',
    },
    {
      name: 'new_inbox_rule',
      description: 'new_inbox_rule',
    },
    {
      name: 'new_transport_rule',
      description: 'new_transport_rule',
    },
    {
      name: 'process_api_call',
      description: 'process_api_call',
    },
    {
      name: 'process_create',
      description: 'process_create',
    },
    {
      name: 'process_create_fork',
      description: 'process_create_fork',
    },
    {
      name: 'process_injection',
      description: 'process_injection',
    },
    {
      name: 'process_injection_victim',
      description: 'process_injection_victim',
    },
    {
      name: 'process_signal',
      description: 'process_signal',
    },
    {
      name: 'process_started_by_service',
      description: 'process_started_by_service',
    },
    {
      name: 'process_terminate',
      description: 'process_terminate',
    },
    {
      name: 'process_token_impersonation',
      description: 'process_token_impersonation',
    },
    {
      name: 'process_update_flags',
      description: 'process_update_flags',
    },
    {
      name: 'rdp_connection',
      description: 'rdp_connection',
    },
    {
      name: 'reg_process_executed',
      description: 'reg_process_executed',
    },
    {
      name: 'regedit_process_executed',
      description: 'regedit_process_executed',
    },
    {
      name: 'register_driver',
      description: 'register_driver',
    },
    {
      name: 'registry_access_delete',
      description: 'registry_access_delete',
    },
    {
      name: 'registry_access_write',
      description: 'registry_access_write',
    },
    {
      name: 'registry_import',
      description: 'registry_import',
    },
    {
      name: 'registry_key',
      description: 'registry_key',
    },
    {
      name: 'registry_key_create',
      description: 'registry_key_create',
    },
    {
      name: 'registry_key_delete',
      description: 'registry_key_delete',
    },
    {
      name: 'registry_value',
      description: 'registry_value',
    },
    {
      name: 'registry_value_create',
      description: 'registry_value_create',
    },
    {
      name: 'registry_value_delete',
      description: 'registry_value_delete',
    },
    {
      name: 'registry_value_write',
      description: 'registry_value_write',
    },
    {
      name: 'regsvr32_process_executed',
      description: 'regsvr32_process_executed',
    },
    {
      name: 'route_process_executed',
      description: 'route_process_executed',
    },
    {
      name: 'rpc_remote_registry_access',
      description: 'rpc_remote_registry_access',
    },
    {
      name: 'rpc_samr_discovery',
      description: 'rpc_samr_discovery',
    },
    {
      name: 'sch_tasks_process_executed',
      description: 'sch_tasks_process_executed',
    },
    {
      name: 'scheduled_task_create',
      description: 'scheduled_task_create',
    },
    {
      name: 'scheduled_task_delete',
      description: 'scheduled_task_delete',
    },
    {
      name: 'scheduled_task_executed',
      description: 'scheduled_task_executed',
    },
    {
      name: 'scheduled_task_modify',
      description: 'scheduled_task_modify',
    },
    {
      name: 'search_created',
      description: 'search_created',
    },
    {
      name: 'search_export_downloaded',
      description: 'search_export_downloaded',
    },
    {
      name: 'search_query_performed',
      description: 'search_query_performed',
    },
    {
      name: 'search_results_purged',
      description: 'search_results_purged',
    },
    {
      name: 'search_started',
      description: 'search_started',
    },
    {
      name: 'secure_link_created',
      description: 'secure_link_created',
    },
    {
      name: 'secure_link_used',
      description: 'secure_link_used',
    },
    {
      name: 'service_added',
      description: 'service_added',
    },
    {
      name: 'service_change_status',
      description: 'service_change_status',
    },
    {
      name: 'service_control_process_executed',
      description: 'service_control_process_executed',
    },
    {
      name: 'service_control_usage',
      description: 'service_control_usage',
    },
    {
      name: 'service_execution',
      description: 'service_execution',
    },
    {
      name: 'service_modify',
      description: 'service_modify',
    },
    {
      name: 'servicesc_start',
      description: 'servicesc_start',
    },
    {
      name: 'service_started',
      description: 'service_started',
    },
    {
      name: 'set_inbox_rule',
      description: 'set_inbox_rule',
    },
    {
      name: 'set_transport_rule',
      description: 'set_transport_rule',
    },
    {
      name: 'setting_changed',
      description: 'setting_changed',
    },
    {
      name: 'sharing_policy_changed',
      description: 'sharing_policy_changed',
    },
    {
      name: 'shim_file_write',
      description: 'shim_file_write',
    },
    {
      name: 'shutdown_process_executed',
      description: 'shutdown_process_executed',
    },
    {
      name: 'smb_file_transfer',
      description: 'smb_file_transfer',
    },
    {
      name: 'smb_tree_connection',
      description: 'smb_tree_connection',
    },
    {
      name: 'ssl_connection',
      description: 'ssl_connection',
    },
    {
      name: 'suspicious_atc_generic_event',
      description: 'suspicious_atc_generic_event',
    },
    {
      name: 'suspicious_connection',
      description: 'suspicious_connection',
    },
    {
      name: 'suspicious_executable_file_write',
      description: 'suspicious_executable_file_write',
    },
    {
      name: 'temporary_file_create',
      description: 'temporary_file_create',
    },
    {
      name: 'temporary_file_read',
      description: 'temporary_file_read',
    },
    {
      name: 'temporary_file_write',
      description: 'temporary_file_write',
    },
    {
      name: 'trafficscan_detection',
      description: 'trafficscan_detection',
    },
    {
      name: 'udp_scan',
      description: 'udp_scan',
    },
    {
      name: 'unsafe_certificate',
      description: 'unsafe_certificate',
    },
    {
      name: 'update_application',
      description: 'update_application',
    },
    {
      name: 'update_application_certificates',
      description: 'update_application_certificates',
    },
    {
      name: 'update_service_principal',
      description: 'update_service_principal',
    },
    {
      name: 'update_user',
      description: 'update_user',
    },
    {
      name: 'user',
      description: 'user',
    },
    {
      name: 'user_account_settings_change',
      description: 'user_account_settings_change',
    },
    {
      name: 'user_logged_in',
      description: 'user_logged_in',
    },
    {
      name: 'user_login',
      description: 'user_login',
    },
    {
      name: 'user_logon',
      description: 'user_logon',
    },
    {
      name: 'user_logon_failed',
      description: 'fiuser_logon_failedle',
    },
    {
      name: 'user_logout',
      description: 'user_logout',
    },
    {
      name: 'user_sessions_list',
      description: 'user_sessions_list',
    },
    {
      name: 'virtualbox_registry_access',
      description: 'virtualbox_registry_access',
    },
    {
      name: 'vm_registry_access',
      description: 'vm_registry_access',
    },
    {
      name: 'vmware_registry_access',
      description: 'vmware_registry_access',
    },
    {
      name: 'windows_remote_management',
      description: 'windows_remote_management',
    },
    {
      name: 'wmi_service_started',
      description: 'wmi_service_started',
    },
    {
      name: 'wmic_process_executed',
      description: 'wmic_process_executed',
    },
    {
      name: 'wscript_process_executed',
      description: 'wscript_process_executed',
    },
  ],
  'other.event_type': [
    {
      name: 'raw',
      description: 'raw',
    },
    {
      name: 'alert',
      description: 'alert',
    },
    {
      name: 'xalert',
      description: 'xalert',
    },
  ],
  'other.os': [
    {
      name: 'windows',
      description: 'windows',
    },
    {
      name: 'linux',
      description: 'linux',
    },
    {
      name: 'macos',
      description: 'macos',
    },
  ],
  'other.sensor_name': [
    {
      name: 'atc',
      description: 'atc',
    },
    {
      name: 'edr',
      description: 'edr',
    },
    {
      name: 'filescan',
      description: 'filescan',
    },
    {
      name: 'trafficscan',
      description: 'trafficscan',
    },
    {
      name: 'o365mails',
      description: 'o365mails',
    },
    {
      name: 'endpoint',
      description: 'endpoint',
    },
    {
      name: 'xdr',
      description: 'xdr',
    },
    {
      name: 'PHASR',
      description: 'PHASR',
    }
  ],
  'other.compliance_center_event': [
    {
      name: 'true',
      description: 'true',
    },
    {
      name: 'false',
      description: 'false',
    },
  ],
  'other.result_status': [
    {
      name: 'true',
      description: 'true',
    },
    {
      name: 'false',
      description: 'false',
    },
    {
      name: 'successful',
      description: 'successful',
    },
    {
      name: 'failed',
      description: 'failed',
    },
    {
      name: 'unknown',
      description: 'unknown',
    },
    {
      name: 'invalid',
      description: 'invalid',
    },
    {
      name: 'none',
      description: 'none',
    },
    {
      name: 'running',
      description: 'running',
    },
    {
      name: 'stopped',
      description: 'stopped',
    },
  ],
  'user.type': [
    {
      name: 'user',
      description: 'user',
    },
    {
      name: 'organization_administrator',
      description: 'organization_administrator',
    },
    {
      name: 'datacenter_account',
      description: 'datacenter_account',
    },
    {
      name: 'system_acount',
      description: 'system_acount',
    },
    {
      name: 'application',
      description: 'application',
    },
    {
      name: 'service',
      description: 'service',
    },
    {
      name: 'custom_policy',
      description: 'custom_policy',
    },
    {
      name: 'system_policy',
      description: 'system_policy',
    },
  ],
  'user.logon_type': [
    {
      name: 'system',
      description: 'system',
    },
    {
      name: 'interactive',
      description: 'interactive',
    },
    {
      name: 'network',
      description: 'network',
    },
    {
      name: 'batch',
      description: 'batch',
    },
    {
      name: 'service',
      description: 'service',
    },
    {
      name: 'unlock',
      description: 'unlock',
    },
    {
      name: 'networkcleartext',
      description: 'networkcleartext',
    },
    {
      name: 'newcredentials',
      description: 'newcredentials',
    },
    {
      name: 'remoteinteractive',
      description: 'remoteinteractive',
    },
    {
      name: 'cachedinteractive',
      description: 'cachedinteractive',
    },
    {
      name: 'cachedremoteinteractive',
      description: 'cachedremoteinteractive',
    },
    {
      name: 'cachedunlock',
      description: 'cachedunlock',
    },
    {
      name: 'invalid',
      description: 'invalid',
    },
  ],
  'user.operation': [
    {
      name: 'none',
      description: 'none',
    },
    {
      name: 'enable_account',
      description: 'enable_account',
    },
    {
      name: 'disable_account',
      description: 'disable_account',
    },
    {
      name: 'delete_account',
      description: 'delete_account',
    },
    {
      name: 'lock_account',
      description: 'lock_account',
    },
    {
      name: 'unlock_account',
      description: 'unlock_account',
    },
    {
      name: 'change_password',
      description: 'change_password',
    },
    {
      name: 'reset_password',
      description: 'reset_password',
    },
    {
      name: 'add_to_security_group',
      description: 'add_to_security_group',
    },
    {
      name: 'remove_from_security_group',
      description: 'remove_from_security_group',
    },
    {
      name: 'unknown',
      description: 'unknown',
    },
  ],
  'network.operation': [
    {
      name: 'connect',
      description: 'connect',
    },
    {
      name: 'disconnect',
      description: 'disconnect',
    },
  ],
};

function buildFieldValues(field: string) {
  if (!field || !FIELD_VALUES[field]) {
    return [];
  }

  return {
    provideCompletionItems: async value => {
      return {
        incomplete: true,
        items: FIELD_VALUES[field].filter(item =>
          value.indexOf('*') === -1 &&
          value.indexOf('?') === -1 &&
          item.name.search(value.replaceAll(",", "")) !== -1
        ),
      };
    },
    validate: async value => {
      return (
        value.indexOf('*') !== -1 ||
        value.indexOf('?') !== -1 ||
        FIELD_VALUES[field].filter(item => item.name === value.replaceAll(",", "")).length > 0
      );
    },
  };
}

const NETWORK_FIELDS = [
  {
    name: 'network.hostname',
    description: 'The hostname.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.bytes_in',
    description: 'Number of bytes transferred in, non-zero.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'network.bytes_out',
    description: 'Number of bytes transferred out, non-zero.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'network.destination_port',
    description: 'Destination port.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'network.destination_ip',
    description: 'Destination IP address.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.direction',
    description: 'The direction of the network traffic.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('network.direction'),
  },
  {
    name: 'network.file_path',
    description: 'The path of the transferred file.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.mac',
    description: 'The MAC address of the endpoint making the request.',
    invalidMessage: 'Invalid value',
    needsBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'network.protocol',
    description: 'Protocol used for the network traffic.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.request_method',
    description: 'The type of request method (GET, POST etc.).',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.source_ip',
    description: 'Source IP address.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.source_port',
    description: 'Source port.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'network.status_code',
    description: 'The request code (200, 300, etc.)',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'network.stream_type',
    description: 'The response method for the stream, for example, application/x-msdownload.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.uri',
    description: 'The accessed URL that triggered the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.container_id',
    description: 'The container id.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.container_name',
    description: 'The container name.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'network.operation',
    description: 'The operation name.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('network.operation'),
  },
  {
    name: 'network.domain_name',
    description: 'The domain name.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
];

const PROCESS_FIELDS = [
  {
    name: 'process.access_privileges',
    description: 'Two possible values: elevated, restricted. ',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('process.access_privileges'),
  },
  {
    name: 'process.command_line',
    description: 'The command line that started the process.',
    invalidMessage: 'Invalid value',
    needsBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'process.injection_target_path',
    description: 'The path of the executable that generated the Target process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.injection_target_pid',
    description: 'The identifier of the injected process.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'process.injection_writer_path',
    description: 'The path of the executable that generated the Writer process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.injection_writer_pid',
    description: 'The identifier of the process that injects another process.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'process.integrity_level',
    description: 'The process integrity.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('process.integrity_level'),
  },
  {
    name: 'process.module',
    description: 'The name of the loaded module that triggered the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.module_pid',
    description: 'The pid of the process that loaded the module.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsNumericBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.parent_access_privileges',
    description: 'Two possible values: elevated, restricted.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('process.parent_access_privileges'),
  },
  {
    name: 'process.parent_cmdline',
    description: 'The command line that started the parent process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.parent_integrity_level',
    description: 'The parent process integrity.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('process.parent_integrity_level'),
  },
  {
    name: 'process.parent_path',
    description: 'The parent process path.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.parent_pid',
    description: 'The parent process identifier.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsNumericBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.parent_user',
    description: 'The user who started the parent process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.path',
    description: 'The process path.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.pid',
    description: 'The process identifier.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsNumericBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.user',
    description: 'The user who started the process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.name',
    description: 'The process name.',
    invalidMessage: 'Invalid value',
    needsBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'process.sha256',
    description: 'The sha256 hash of the process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.md5',
    description: 'The md5 hash of the process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.service_start_type',
    description: 'The start type of the service.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('process.service_start_type'),
  },
  {
    name: 'process.is_driver',
    description: 'If the process is driver or not.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('process.is_driver'),
  },
  {
    name: 'process.service_name',
    description: 'The name of the service.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.new_service_name',
    description: 'The service name.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.target_path',
    description: 'The path of the executable that generated the Target process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.target_name',
    description: 'The name of the executable that generated the Target process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.task_name',
    description: 'The name of the task.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.injection_method',
    description: 'The injection method of the process.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'process.create_type',
    description: 'The create type of the process.',
    invalidMessage: 'Invalid value',
    needsBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
];

const FILE_FIELDS = [
  {
    name: 'file.attribute_operation',
    description: 'The type of operation involved in changing a file attribute.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('file.attribute_operation'),
  },
  {
    name: 'file.md5',
    description: 'The md5 hash of the file accessed, if the file is an executable.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.operation',
    description: 'The type of operation on a file.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('file.operation'),
  },
  {
    name: 'file.path',
    description: 'The file path of the file that triggered the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.old_path',
    description: 'The old file path of the file that triggered the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.sha256',
    description: 'The sha256 hash of the file accessed, if the file is an executable.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.size',
    description: 'The file size.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'file.name',
    description: 'The path of the file from which a copy/move operation takes place.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.ext',
    description: 'The extension of the file that is being copy/moved.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.url',
    description: 'file url',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.site',
    description: 'file site',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.destination_url',
    description: 'file destination url',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.destination_file',
    description: 'destination file',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'file.item_type',
    description: 'item type',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('file.item_type'),
  },
  {
    name: 'file.is_remote',
    description: 'is file from remote event',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('file.is_remote'),
  },
];

const REGISTRY_FIELDS = [
  {
    name: 'registry.data',
    description: 'The registry value that has been modified.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'registry.key',
    description: 'The folder of the registry key that generated the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'registry.operation',
    description: 'The type of data access.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('registry.operation'),
  },
  {
    name: 'registry.type',
    description: 'The type of registry data.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('registry.type'),
  },
  {
    name: 'registry.value',
    description: 'The registry value.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    values: [],
  },
];

const EMAIL_FIELDS = [
  {
    name: 'email.attachments_hashes',
    description: 'Attachment hashes.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.attachments_names',
    description: 'Attachments names.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.attachments_size',
    description: 'Attachments size.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.attachments_number',
    description: 'Count of the number of attachments.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.attachments_types',
    description: 'Attachment types.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.attachments_uris',
    description: 'A list of all the URLs found in the email.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.date',
    description: 'The date the email was sent.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.event_name',
    description: 'Event name.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.origin_ip',
    description: 'The origin ip value from where the email was sent.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.receiver',
    description: 'The email address of the receiver.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.receiver_address',
    description: 'The email address of the receiver.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.receiver_name',
    description: 'The email name of the receiver.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.sender',
    description: 'The email address of the sender.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.sender_address',
    description: 'The email address of the sender.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.sender_name',
    description: 'The email name of the sender.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.subject',
    description: 'Email subject.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.path',
    description: 'path',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.mailbox_owner',
    description: 'mailbox owner',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.mailbox_guid',
    description: 'mailbox guid',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.logon_type',
    description: 'logon type',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('email.logon_type'),
  },
  {
    name: 'email.login_status',
    description: 'login status',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.client',
    description: 'client',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.parameters.name',
    description: 'parameters',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.parameters.value',
    description: 'parameters',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.id',
    description: 'id',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.to_address',
    description: 'to_address',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.to_name',
    description: 'to_name',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.from_address',
    description: 'from_address',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.from_name',
    description: 'from_name',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.cc_address',
    description: 'cc_address',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.cc_name',
    description: 'cc_name',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.bcc_address',
    description: 'bcc_address',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'email.bcc_name',
    description: 'bcc_name',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
];

const ALERT_FIELDS = [
  {
    name: 'alert.id',
    description: 'The unique id of the alert',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    values: [],
  },
  {
    name: 'alert.actions_taken',
    description: 'Actions taken on the file.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('alert.actions_taken'),
  },
  {
    name: 'alert.att&ck_subtechnique',
    description: 'Some Mitre techniques have subtechniques. This field describes the subtechnique name.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'alert.att&ck_subtechnique_id',
    description: 'Some Mitre techniques have subtechniques.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'alert.att&ck_tactic',
    description: 'All Mitre techniques have a Tactic under which they are categorized.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'alert.att&ck_technique',
    description: 'The Mitre technique name, as documented on the official website.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'alert.att&ck_technique_id',
    description: 'The Mitre Technique ID, as documented on the official website.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'alert.mark',
    description: 'The type of alert.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('alert.mark'),
  },
  {
    name: 'alert.name',
    description: 'Alert name.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'alert.scan_type',
    description: 'scan type',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('alert.scan_type'),
  },
  {
    name: 'alert.severity_score',
    description: 'Alert score.',
    invalidMessage: 'Invalid value',
    needsNumericBackendCompletion: true,
    forceSelection: false,
    values: [],
  },
  {
    name: 'alert.type',
    description: 'The type of technology that generated the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('alert.type'),
  },
  {
    name: 'alert.incident_number',
    description: 'Incident number.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    values: [],
  },
  {
    name: 'alert.incident_id',
    description: 'Incident id.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    values: [],
  },
];

const OTHER_FIELDS = [
  {
    name: 'other.api',
    description: 'The name of the hooked Windows API that generated the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.arch',
    description: 'arch',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('other.arch'),
  },
  {
    name: 'other.detection_class',
    description: 'The type of detection.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('other.detection_class'),
  },
  {
    name: 'other.event_id',
    description: 'The unique ID of the event.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.event_name',
    description: 'The name of the event.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    values: buildFieldValues('other.event_name'),
  },
  {
    name: 'other.event_type',
    description: 'Event type.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('other.event_type'),
  },
  {
    name: 'other.rule_id',
    description: 'The exception or detection ID.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.hostname',
    description: 'hostname',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.os',
    description: 'The type of OS.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('other.os'),
  },
  {
    name: 'other.sensor_name',
    description: 'The sensor that generated the alert.',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('other.sensor_name'),
  },
  {
    name: 'other.user',
    description: 'Logged on user at the time of the event.',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.agent',
    description: 'agent',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.compliance_center_event',
    description: 'compliance center event',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('other.compliance_center_event'),
  },
  {
    name: 'other.result_status',
    description: 'result status',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('other.result_status'),
  },
  {
    name: 'other.record_type',
    description: 'record type',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.organization_id',
    description: 'organization id',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.ip',
    description: 'ip',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'other.script',
    description: 'script',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
];

const USER_FIELDS = [
  {
    name: 'user.name',
    description: 'user name',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.email',
    description: 'user email',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.type',
    description: 'user type',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('user.type'),
  },
  {
    name: 'user.id',
    description: 'user id',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.domain',
    description: 'user domain',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.shared_with',
    description: 'user shared with',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.target',
    description: 'user target',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.sharing_permissions',
    description: 'user sharing permissions',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.modified_properties',
    description: 'user modified properties',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.team_name',
    description: 'user team name',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.team_guid',
    description: 'user team guid',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.team_members',
    description: 'user team members',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.extended_properties',
    description: 'user extended properties',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.external_access',
    description: 'user external access',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'user.logon_type',
    description: 'user logon type',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('user.logon_type'),
  },
  {
    name: 'user.operation',
    description: 'user operation',
    invalidMessage: 'Invalid value',
    forceSelection: true,
    values: buildFieldValues('user.operation'),
  },
];

const RESOURCE_FIELDS = [
  {
    name: 'resource.name',
    description: 'resource name',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.type',
    description: 'resource type',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.data',
    description: 'resource data',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: false,
    values: [],
  },
  {
    name: 'resource.id',
    description: 'resource id',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.app_address',
    description: 'resource app_address',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.policy_type',
    description: 'resource policy_type',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.url',
    description: 'resource url',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.path',
    description: 'resource path',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.size',
    description: 'resource size',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.md5',
    description: 'resource md5',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.sha256',
    description: 'resource sha256',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: true,
    values: [],
  },
  {
    name: 'resource.ssh_public_key',
    description: 'resource ssh_public_key',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: false,
    values: [],
  },
];

const SCHEMA_OPERATORS_ITEMS = [
  {
    name: 'AND',
    description: 'Used when both operands are true.',
  },
  {
    name: 'AND NOT',
    description: 'Used when first operand is true and second operand is false.',
  },
  {
    name: 'OR',
    description: 'Used when any of the operands is true.',
  },
];

export const SCHEMA_FIELDS_ITEMS = [
  ...NETWORK_FIELDS,
  ...PROCESS_FIELDS,
  ...FILE_FIELDS,
  ...REGISTRY_FIELDS,
  ...EMAIL_FIELDS,
  ...ALERT_FIELDS,
  ...OTHER_FIELDS,
  ...USER_FIELDS,
  ...RESOURCE_FIELDS,
];

function buildExistsOperatorFieldValues() {
  const fieldValues: any = [];
  for (const field of SCHEMA_FIELDS_ITEMS) {
    fieldValues.push({
      name: field.name,
      description: field.description,
    });
  }
  return fieldValues;
}

const OPERATOR_FIELDS = [
  {
    name: '_exists_',
    description: '_exists_',
    invalidMessage: 'Invalid value',
    forceSelection: false,
    needsBackendCompletion: false,
    values: buildExistsOperatorFieldValues(),
  }
];

SCHEMA_FIELDS_ITEMS.push(...OPERATOR_FIELDS);

export const CODE_EDITOR_OPTIONS = {
  languageOptions: {
    validate: true,
    autoComplete: true,
    hover: true,
    schema: {
      fields: {
        forceSelection: true,
        invalidMessage: 'Invalid field',
        items: SCHEMA_FIELDS_ITEMS,
      },
      operators: {
        forceSelection: true,
        invalidMessage: 'Invalid operator',
        items: SCHEMA_OPERATORS_ITEMS,
      },
    },
  },
};

export const HELPER_LINKS = {
  partner:
    'https://www.bitdefender.com/business/support/en/77211-151142-investigating-incidents.html#UUID-75f12844-8bb7-8f1f-2b3b-0288df0dc679',
  endUser:
    'https://www.bitdefender.com/business/support/en/77209-151142-investigating-incidents.html#UUID-75f12844-8bb7-8f1f-2b3b-0288df0dc679',
};
